<template>
  <div class="tab">
    <p class="pt-5">{{ offer.points }} points</p>
    <img
      class="dot"
      v-if="offer.paywithpoints"
      :src="require('@/assets/payWithPoints.svg')"
      :alt="offer.name"
    />
    <div class="dot" v-else>
      <img :src="offer.image" :alt="offer.name" />
    </div>
    <p :title="offer.name" class="offer-name pt-3 text-center">
      {{ offer.name }}
    </p>
  </div>
</template>

<script>
export default {
  name: "PointsTab",
  components: {},
  props: {
    offer: Object,
  },
};
</script>

<style scoped>
.dot {
  height: 85px;
  width: 85px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
}
img {
  mix-blend-mode: multiply;
  height: 60px;
  border-radius: 50%;
}

.offer-name {
  max-width: 90%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
